import { makeVar } from '@apollo/client';

let imageObject = {};

export const cacheImageObject = makeVar(imageObject);

